import React from "react";

const Navbar = () => {

    return(
        <navbar id='Home' className={`absolute top-0 left-0 width-screen justify-center sm:justify-between z-50 flex w-full px-20 py-5 bg-[#151934] `}>
        <div className='flex gap-2 items-center'>
            <img 
                src='/images/NetreachLogo_v2.png' 
                alt='NetReach Logo'
                className='w-[80px]'
            />
            <span className='text-white font-bold text-[20px]'>NetReach</span>
        </div>
        {/* <ul className='text-white items-center hidden md:flex gap-5 text-[18px] absolute left-1/2 transform -translate-y-[20px] -translate-x-1/2 h-full'>
            {['Home', 'About', 'Services', 'Contact Us'].map((link) => (
                <li
                    key={link}
                    className={`cursor-pointer ${activeLink === link ? 'opacity-100' : 'opacity-70'}`}
                    onClick={() => navClickFunc(link)} // Set active link on click
                >
                    {link}
                </li>
            ))}
        </ul> */}
        {/* <button className='bg-[#3288C3] hidden md:block text-white rounded-[50px] px-5 py-3' onClick={() => navClickFunc('Contact Us')}>Get a Demo</button> */}
    </navbar>
    )
}

export default Navbar;